const GA_ID = "G-Y2GQ8NQK3H";

function gtag(...args) {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag(...args);
  }
}

// Fired on every route change (SPA — gtag's auto page_view is disabled)
export function trackPageView(path) {
  gtag("config", GA_ID, { page_path: path });
}

export function trackEvent(eventName, params = {}) {
  gtag("event", eventName, params);
}

export const analytics = {
  // ── Hero CTAs ──────────────────────────────────────────────
  clickExplore:      ()  => trackEvent("click_explore_community"),
  clickJoinFree:     ()  => trackEvent("click_join_free_hero"),

  // ── Newsletter ─────────────────────────────────────────────
  newsletterSignup:  ()  => trackEvent("newsletter_signup", { method: "email" }),

  // ── Content submission (all sections, via FormDialog) ───────
  // resource is "posts" | "events" | "jobs" | "housing" | "business"
  openForm:    (resource) => trackEvent("form_open",   { resource }),
  submitForm:  (resource) => trackEvent("form_submit", { resource }),
  formError:   (resource) => trackEvent("form_error",  { resource }),

  // ── Photo uploads ──────────────────────────────────────────
  uploadPhoto: (count)    => trackEvent("upload_photo", { count }),
  uploadError: ()         => trackEvent("upload_error"),

  // ── Post engagement ────────────────────────────────────────
  likePost:    (postId)   => trackEvent("like_post",    { post_id: postId }),
  unlikePost:  (postId)   => trackEvent("unlike_post",  { post_id: postId }),
  openReplies: (postId)   => trackEvent("open_replies", { post_id: postId }),
  submitReply: (postId)   => trackEvent("submit_reply", { post_id: postId }),

  // ── Browsing ───────────────────────────────────────────────
  filterTopic:   (topic)  => trackEvent("filter_topic",  { topic }),
  filterRegion:  (region) => trackEvent("filter_region", { region }),
  filterJobs:    (flag)   => trackEvent("filter_jobs",   { flag }),
  sortPosts:     (sort)   => trackEvent("sort_posts",   { sort }),
  searchPosts:   (term)   => trackEvent("search_posts", { search_term: term }),
  loadMorePosts: ()       => trackEvent("load_more_posts"),

  // ── Feedback ───────────────────────────────────────────────
  submitFeedback: (category, rating) =>
    trackEvent("submit_feedback", { category, rating }),

  // ── Outbound links ─────────────────────────────────────────
  clickOutbound: (label)  => trackEvent("click_outbound", { label }),
};
